<template>
  <el-dialog
    class="BaseModal"
    ref="BaseModal"
    append-to-body
    :destroy-on-close="destroyOnClose"
    :close-on-click-modal="false"
    v-drag
    v-bind="options"
    :visible="visible"
    @close="close"
  >
    <template slot="title">
      <div class="header">
        <div class="left">{{ options.title }}</div>
        <div class="right">
          <el-button
            v-if="options.showConfirm"
            type="primary"
            size="mini"
            @click="confirm"
            >{{ options.confirmText }}</el-button
          >
          <el-button
            v-if="options.resetText"
            type="primary"
            size="mini"
            @click="reset"
            >{{ options.resetText }}</el-button
          >
        </div>
      </div>
    </template>
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    destroyOnClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      options: {
        title: '基础弹窗',
        confirmText: '确定',
        resetText: '',
        width: '350px',
        showConfirm: true
      }
    }
  },
  mounted() {},
  methods: {
    // 显示弹窗
    show(options = {}) {
      this.options = { ...this.options, ...options }
      this.visible = true
      this.$refs.BaseModal.$el.firstChild.style.top = '150px'
    },
    confirm() {
      this.$emit('confirm', this.close)
    },
    reset() {
      this.$emit('reset', this.close)
    },
    // 关闭弹窗
    close() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.BaseModal {
  ::v-deep .el-dialog {
    margin-top: unset !important;
  }
  ::v-deep .el-dialog__header {
    background: #f2f2f2;
    height: 40px;
    padding: 16px 50px 0px 16px;

    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        font-weight: 600;
      }
    }
  }

  ::v-deep .el-dialog__body {
    background: #f2f2f2;
    padding: 12px 16px;
  }
}
</style>
